import axios from 'axios'

// providers
import envProvider from '@/providers/envProvider.ts'

const apiInstance = axios.create({
  baseURL: `${envProvider.baseURL}/api`,
})

export default apiInstance
